import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Change Router to BrowserRouter
import Index from './pages';
import OnePAge from './pages/onepage';
import Aboutus from './pages/aboutus';
import Services from './pages/services';
import Volunteer from './pages/volunteer';
import Donate from './pages/donate';
import Team from './pages/team';
import Gallery from './pages/gallery';
import Testimonial from './pages/testimonial';
import Faqs from './pages/faqs';
import Blogs from './pages/blogs';
import BlogSidebar from './pages/blog-sidebar';
import BlogDetail from './pages/blog-detail';
import Login from './pages/login';
import Signup from './pages/signup';
import ResetPassword from './pages/reset-password';
import LockScreen from './pages/lock-screen';
import Terms from './pages/terms';
import Privacy from './pages/privacy';
import Comingsoon from './pages/comingsoon';
import Maintenance from './pages/maintenance';
import Error from './pages/error';
import Contactus from './pages/contactus';
import { HelmetProvider, Helmet } from 'react-helmet-async';


function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={
              <>
                <Helmet>
                  <title>Home | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Tu Es Belle Foundation" />
                  <meta name="description" content="Discover how Tu Es Belle Foundation empowers women and girls through education, mental health support, and skill-building. Fearfully and Wonderfully Made." />
                  <meta name="keywords" content="Tu Es Belle, women empowerment, education for girls, mental health support, skill-building, gender equality, Proverbs 31:25, women's rights" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Tu Es Belle Foundation" />
                  <meta property="og:description" content="Fearfully and Wonderfully Made. Join us in empowering women and girls through education, mental health support, and skill-building." />
                  <meta property="og:url" content="https://tu-es-belle.org" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Index />
              </>
            } 
          />


          <Route path="/onepage" element={<OnePAge />} />


          <Route 
            path="/aboutus" 
            element={
              <>
                <Helmet>
                  <title>About Us | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="About Us" />
                  <meta name="description" content="Learn more about Tu Es Belle Foundation's vision, mission, and journey to empower women and girls worldwide. Fearfully and Wonderfully Made." />
                  <meta name="keywords" content="about Tu Es Belle, female empowerment, mission, vision, women support, gender equality, women's rights, Proverbs 31:25" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="About Tu Es Belle Foundation" />
                  <meta property="og:description" content="Explore our journey and commitment to empowering women and girls. Discover how we bring Christ-centered values to societal change." />
                  <meta property="og:url" content="https://tu-es-belle.org/aboutus" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Aboutus />
              </>
            } 
          />


          <Route 
            path="/services" 
            element={
              <>
                <Helmet>
                  <title>Services | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Our Services" />
                  <meta name="description" content="Discover our services in empowering women through education, mental health support, skill-building, and financial empowerment. Join us today." />
                  <meta name="keywords" content="Tu Es Belle services, education, Moral Empowerment, Social Justice Advocacy, Income-Generating Products,Creative Arts Empowerment,Physiological Empowerment, Community Building,  mental health, skills, financial empowerment, women's empowerment, Project Boss Lady, skill training" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Services at Tu Es Belle Foundation" />
                  <meta property="og:description" content="Learn how our services transform lives through skill-building, education, and support for women and girls." />
                  <meta property="og:url" content="https://tu-es-belle.org/services" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Services />
              </>
            } 
          />


          <Route 
            path="/contactus" 
            element={
              <>
                <Helmet>
                  <title>Contact Us | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Contact Us" />
                  <meta name="description" content="Get in touch with Tu Es Belle Foundation for inquiries, volunteering opportunities, or partnerships. We're here to work together." />
                  <meta name="keywords" content="contact Tu Es Belle, women's support, empowerment contact, volunteer contact, partnership inquiries" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Contact Us" />
                  <meta property="og:description" content="Reach out to us for partnerships, volunteering, or more information about our mission and vision." />
                  <meta property="og:url" content="https://tu-es-belle.org/contactus" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Contactus />
              </>
            } 
          />


          <Route 
            path="/volunteer" 
            element={
              <>
                <Helmet>
                  <title>Volunteer | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Get Involved" />
                  <meta name="description" content="Join us in empowering women and girls by volunteering with Tu Es Belle Foundation. Be part of a Christ-centered mission." />
                  <meta name="keywords" content="volunteer Tu Es Belle, women's empowerment, help women, support girls, volunteer opportunity, Proverbs 31:25" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Volunteer with Tu Es Belle Foundation" />
                  <meta property="og:description" content="Make a difference by volunteering with Tu Es Belle Foundation. Empower lives and inspire change." />
                  <meta property="og:url" content="https://tu-es-belle.org/volunteer" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Volunteer />
              </>
            } 
          />


          <Route 
            path="/donate" 
            element={
              <>
                <Helmet>
                  <title>Donate | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Make a donation" />
                  <meta name="description" content="Support Tu Es Belle Foundation's mission by donating. Your generosity empowers women and girls to live fearlessly." />
                  <meta name="keywords" content="donate Tu Es Belle, women's empowerment donations, support girls, help women, give back" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Make a donation" />
                  <meta property="og:description" content="Your donation helps us educate, empower, and inspire women and girls worldwide. Join the mission." />
                  <meta property="og:url" content="https://tu-es-belle.org/donate" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Donate />
              </>
            } 
          />


          <Route 
            path="/team" 
            element={
              <>
                <Helmet>
                  <title>Team | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Our Team" />
                  <meta name="description" content="Meet the passionate individuals behind Tu Es Belle Foundation who are dedicated to empowering women and girls." />
                  <meta name="keywords" content="Tu Es Belle team, leadership, women's empowerment team, team profiles" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Our Team" />
                  <meta property="og:description" content="Get to know the dedicated team working to make Tu Es Belle Foundation's mission a reality." />
                  <meta property="og:url" content="https://tu-es-belle.org/team" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Team />
              </>
            } 
          />

          <Route 
            path="/gallery" 
            element={
              <>
                <Helmet>
                  <title>Gallery | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Our Gallery" />
                  <meta name="description" content="Meet the passionate individuals behind Tu Es Belle Foundation who are dedicated to empowering women and girls." />
                  <meta name="keywords" content="Tu Es Belle gallery, leadership, women's empowerment gallery, gallery profiles" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Our Gallery" />
                  <meta property="og:description" content="Get to know the dedicated gallery working to make Tu Es Belle Foundation's mission a reality." />
                  <meta property="og:url" content="https://tu-es-belle.org/gallery" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Gallery />
              </>
            } 
          />

          <Route 
            path="/blogs" 
            element={
              <>
                <Helmet>
                  <title>Blog | Tu Es Belle</title>
                  {/* meta tags */}
                  <meta name="title" content="Our Blog" />
                  <meta name="description" content="Explore insightful blogs about women's empowerment, education, mental health, and more from Tu Es Belle Foundation." />
                  <meta name="keywords" content="Tu Es Belle blogs, women's rights articles, empowerment insights, education, mental health" />
                  <meta name="author" content="Tu Es Belle Foundation" />
                  {/* open graph tags */}
                  <meta property="og:title" content="Our Blog" />
                  <meta property="og:description" content="Stay informed with blogs on female empowerment, education, and skill-building from Tu Es Belle Foundation." />
                  <meta property="og:url" content="https://tu-es-belle.org/blogs" />
                  <meta property="og:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                  <meta property="og:image:alt" content="tu es belle logo" />
                  <meta name="twitter:title" content="Tu Es Belle Foundation | Empowering Women" />
                  <meta name="twitter:description" content="Learn how Tu Es Belle Foundation transforms lives through education, skills, and community-building." />
                  <meta name="twitter:image" content="https://tu-es-belle.org/static/media/logo192.66814c529b1c7d9ce346.png" />
                </Helmet>
                <Blogs />
              </>
            } 
          />


          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/blog-sidebar" element={<BlogSidebar />} />
          <Route path="/blog-detail" element={<BlogDetail />} />
          <Route path="/blog-detail/:id/:url" element={<BlogDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/lock-screen" element={<LockScreen />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/comingsoon" element={<Comingsoon />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/error" element={<Error />} />
          <Route path="*" element={<Error />} />

        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;